module.exports = __webpack_public_path__ + "img/image01_sp.7744e94f.jpg";